import { render, staticRenderFns } from "./HeartAbout.vue?vue&type=template&id=b19520e8"
import script from "./HeartAbout.vue?vue&type=script&lang=js"
export * from "./HeartAbout.vue?vue&type=script&lang=js"
import style0 from "./HeartAbout.vue?vue&type=style&index=0&id=b19520e8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports